import {
  WaMessageTemplateHeader,
  WaMessageTemplateSingleHeader,
} from 'shared/api/requests/whatsApp/schemas'

export const isHeaderWithAttachment = (
  header: WaMessageTemplateHeader,
): header is WaMessageTemplateSingleHeader => {
  return Boolean(!Array.isArray(header) && header?.type)
}
